const axiosRequestConfig = {
    baseURL: process.env.REACT_APP_API_BASE_URL,
    withCredentials: true,
    headers: undefined,

}

export default axiosRequestConfig